<template>
  <v-container fluid>
    <v-dialog
      v-model="showPostulantes"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="success">
          <v-toolbar-title>Lista de Postulantes</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="showPostulantes = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <lista-postulantes
          :trabajo-seleccionado="trabajoSeleccionado"
        ></lista-postulantes>
      </v-card>
    </v-dialog>
    <v-row no-gutters>
      <v-col>
        <template>
          <v-data-table
            fixed-header
            :headers="headers"
            :items="propuestas"
            :loading="fetching"
            class="elevation-1"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Historial de Propuestas</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <div class="flex-grow-1"></div>
                <v-btn
                  color="green"
                  dark
                  v-on:click.native="getForm(1)"
                  :to="{ name: 'Crear Propuesta Empresas' }"
                  >Crear Propuesta</v-btn
                >
              </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    text
                    color="blue"
                    v-on="on"
                    @click="btnDetallePostulantes(item)"
                  >
                    <v-icon class="mx-2">mdi-account-details</v-icon>
                  </v-btn>
                </template>
                <span>Ver Postulantes</span>
              </v-tooltip>
              <ChangePositionStateBtn
                :propuesta="item"
                @update-list="obtenerTrabajos"
              />
            </template>
            <template v-slot:item.estadoTrabajo="{ item }">
              <v-chip :color="getEstado(item.estadoTrabajo)" dark>{{
                item.estadoTrabajo
              }}</v-chip>
            </template>
            <template v-slot:item.fechaPublicacion="{ item }">{{
              formatDate(item.fechaPublicacion)
            }}</template>
            <template v-slot:item.fechaVencimiento="{ item }">{{
              formatDate(item.fechaVencimiento)
            }}</template>
          </v-data-table>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ListaPostulantes from '@/components/company/common/ListaPostulantes.vue'

export default {
  components: {
    ListaPostulantes,
    ChangePositionStateBtn: () =>
      import('@/components/company/buttons/CambiarEstadoTrabajoBtn.vue')
  },
  data: () => ({
    verificado: true,
    headers: [
      { text: 'Puesto Ofrecido', value: 'nombrePuesto', align: 'center' },
      { text: 'Fecha de Creación', value: 'fechaPublicacion', align: 'center' },
      { text: 'Fecha de Fin', value: 'fechaVencimiento', align: 'center' },
      { text: 'Área', value: 'areaEmpresa', align: 'center' },
      {
        text: 'Cantidad de Postulantes',
        value: 'postulantes.length',
        align: 'center'
      },
      {
        text: 'Estado',
        align: 'center',
        sortable: true,
        value: 'estadoTrabajo'
      },
      { text: 'Acciones', value: 'actions', sortable: false }
    ],
    propuestas: [],
    trabajoSeleccionado: {},
    showPostulantes: false
  }),
  methods: {
    getEstado(estado) {
      if (estado == 'ACTIVO') return 'green lighten-2'
      else if (estado == 'INACTIVO') return 'red lighten-2'
      else return 'yellow'
    },

    btnDetallePostulantes(item) {
      this.trabajoSeleccionado = { ...item }
      this.showPostulantes = true
    },

    getForm(i) {
      this.$emit('change', i)
    },

    async obtenerTrabajos() {
      await this.fetchListaTrabajos()
      this.propuestas = this.getListaTrabajos
    },

    ...mapActions('company', ['fetchListaTrabajos'])
  },

  computed: {
    ...mapGetters('company', ['getListaTrabajos']),

    ...mapGetters('user', ['getError', 'fetching'])
  },

  async mounted() {
    this.propuestas = []
    await this.obtenerTrabajos()
  }
}
</script>
